import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { FileQuestion, ArrowLeft, Home, Search } from "lucide-react";

import { Button } from "../../components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "../../components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "../../components/ui/alert";

export default function Error404Shadcn() {
  const { t } = useTranslation("common");
  const history = useHistory();
  const location = useLocation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
            <FileQuestion className="h-8 w-8 text-muted-foreground" />
          </div>
          <h1 className="text-6xl font-bold text-primary">404</h1>
          <p className="text-xl font-semibold text-foreground mt-2">
            {t("error.Page Not Found") || "Page Not Found"}
          </p>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-muted-foreground">
            {t("error.The page you are looking for does not exist") ||
              "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."}
          </p>
          <Alert>
            <Search className="h-4 w-4" />
            <AlertTitle>{t("error.Requested URL") || "Requested URL"}</AlertTitle>
            <AlertDescription className="font-mono text-sm break-all">
              {location.pathname}
            </AlertDescription>
          </Alert>
        </CardContent>
        <CardFooter className="flex gap-2 justify-center">
          <Button variant="outline" onClick={() => history.goBack()}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            {t("button.Go Back") || "Go Back"}
          </Button>
          <Button onClick={() => history.push("/")}>
            <Home className="mr-2 h-4 w-4" />
            {t("button.Go Home") || "Go Home"}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
